import React, { Component } from 'react';

import './QuemSomosPerfil.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';
import Swipeable from 'react-swipeable';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	views
} from '../../settings';

import {
	DelayLink,
	Compromisso
} from '../../components/';

class QuemSomosPerfil extends Component {

	constructor() {
		super();

        this.images = images;

        this.state = {
        	shadowOpacity: 'shown',
        	compromissosStep: null,
        	compromisso0: '',
        	compromisso1: '',
        	compromisso2: '',
        	compromisso3: '',
        	activeButtons: 'compromissos__buttons--0',
        	intervalId: 0,
        	currentSlide: 0,
        	maxSlides: 3,
        	sliderTime: 15000
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	    this.changeCompromissos = this.changeCompromissos.bind(this);
	    this.changeCompromissosButton = this.changeCompromissosButton.bind(this);
	    this.changeCompromissosMobileNext = this.changeCompromissosMobileNext.bind(this);
	    this.changeCompromissosMobilePrev = this.changeCompromissosMobilePrev.bind(this);
	    this.timer = this.timer.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

    changeCompromissos(num) {
    	if (this.state.compromissosStep != num) {
    		this.setState({
    			compromissosStep : num,
    			activeButtons: 'compromissos__buttons--' + num
    		});

    		this.setState({
    			compromisso0 : '',
    			compromisso1 : '',
    			compromisso2 : '',
    			compromisso3 : ''
    		});

    		switch (num) {
    			case 0:
    				this.setState({ compromisso0 : 'active' });
    				break;
    			case 1:
    				this.setState({ compromisso1 : 'active' });
    				break;
    			case 2:
    				this.setState({ compromisso2 : 'active' });
    				break;
    			case 3:
    				this.setState({ compromisso3 : 'active' });
    				break;
    		}
    	}
    }

    changeCompromissosButton(num) {
    	this.changeCompromissos(num);
    	this.clearTimer();
    	this.initTimer();
    }

    changeCompromissosMobileNext() {
    	let nextCompromisso = this.state.compromissosStep + 1;
    	this.changeCompromissos( (nextCompromisso <= this.state.maxSlides) ? nextCompromisso : 0 );
    	this.reloadTimer();
	}

    changeCompromissosMobilePrev() {
    	let prevCompromisso = this.state.compromissosStep - 1;
    	this.changeCompromissos( (prevCompromisso >= 0) ? prevCompromisso : this.state.maxSlides );
    	this.reloadTimer();
	}

	timer() {
		let newSlide;

		if (this.state.compromissosStep < this.state.maxSlides) {
			newSlide = this.state.compromissosStep + 1;
		} else {
			newSlide = 0;
		}

		console.log('newSlide', newSlide);

		this.changeCompromissos(newSlide);
		// this.setState({ compromissosStep : newSlide });
	}

	reloadTimer() {
    	this.clearTimer();
    	this.initTimer();
	}

	clearTimer() {
		clearInterval(this.state.intervalId);
	}

	initTimer() {
		var intervalId = setInterval(this.timer, this.state.sliderTime);
		this.setState({ intervalId: intervalId });
	}

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('2.1 Perfil');
    }

    componentWillUnmount() {
		this.clearTimer();
	}

    componentDidMount() {
    	this.initTimer();
    	this.changeCompromissos(0);
    }

	render() {

		var classItem = [
			'view',
			'quemsomosperfil'
		];

		let slideClassItem = [
			'compromissos__body',
			'compromissos__body--' + this.state.compromissosStep
		];

		let compromissoButtonsClassItem = [
			'container', 'compromissos__buttons', this.state.activeButtons
		];

		let compromisso0ClassItem = [
			'compromissos__btn',
			'compromissos__btn--representar',
			'compromissos__btn--' + this.state.compromisso0
		];

		let compromisso1ClassItem = [
			'compromissos__btn',
			'compromissos__btn--autorregular',
			'compromissos__btn--' + this.state.compromisso1
		];

		let compromisso2ClassItem = [
			'compromissos__btn',
			'compromissos__btn--informar',
			'compromissos__btn--' + this.state.compromisso2
		];

		let compromisso3ClassItem = [
			'compromissos__btn',
			'compromissos__btn--educar',
			'compromissos__btn--' + this.state.compromisso3
		];

        return (

			<div className="views">
			
				<Helmet>
	                <title>2.1 Perfil - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>2.1</span> Perfil</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Quem somos</p>
		        			</div>
		        		</header>

		        		<div className="views__content row">
			        		<div className="container">
			        			
				        		<div className="column column--half">
				        			<Fade bottom>
					        			<p>
					        				Prazer, somos a <b>ANBIMA</b>, <strong>Associação Brasileira das Entidades dos Mercados Financeiro e de Capitais</strong>. Trata-se de uma organização sem fins lucrativos que nasceu em 2009, após a união de duas entidades que juntas somam quase um século de experiência. Ao reunir bancos, gestoras, corretoras, distribuidoras e administradoras, temos o desafio de representar dentro de casa a pluralidade dessas instituições.
					        				<span className="gri_label"><text>GRI 102-1, 102-5, 102-6</text></span>
					        			</p>

					        			<div className="visible_mobile">
					        				<img src={ this.images.quem_somos_perfil } className="move__right" />
					        			</div>

										<p>
											Também viabilizamos, há 38 anos, as atividades do Selic (Sistema Especial de Liquidação e Custódia) por meio de um convênio com o Banco Central. O Selic atua com um sistema informatizado que detém tanto a custódia de títulos do Tesouro Nacional quanto o registro e a liquidação de operações com esses papéis.
										</p>

										<p>
											A partir do escritório em São Paulo (SP) e da sede no Rio de Janeiro (RJ), são organizadas atividades de defesa dos interesses dos associados em torno de quatro compromissos assumidos com o mercado: <strong>representar, autorregular, informar e educar</strong>.
					        				<span className="gri_label"><text>GRI 102-2, 102-3, 102-4</text></span>
										</p>
				        			</Fade>
				        		</div>
			        			
				        		<div className="column column--half column--padding text-center">
				        			<div className="visible_desk">
				        				<img src={ this.images.quem_somos_perfil } className="first_image" />
				        			</div>
				        		</div>

			        		</div>
		        		</div>

		        		<div className="views__content views__content--section row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<h2 className="section_title">Compromissos</h2>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section compromissos">
			        		<Swipeable
		        				className="row compromissos__header"
			        			onSwipedLeft={ this.changeCompromissosMobileNext }
			        			onSwipedRight={ this.changeCompromissosMobilePrev }>

			        			<img className="compromissos_arrow" src={ this.images.quem_somos_perfil_arrow } />

				        		<div className={ compromissoButtonsClassItem.join(' ') }>
					        		<div className={ compromisso0ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 0) }>
					        			<span className="btn__text">Representar</span>
					        			<div className="btn__loader"></div>
					        		</div>
					        		<div className={ compromisso1ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 1) }>
					        			<span className="btn__text">Autorregular</span>
					        			<div className="btn__loader"></div>
					        		</div>
					        		<div className={ compromisso2ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 2) }>
					        			<span className="btn__text">Informar</span>
					        			<div className="btn__loader"></div>
					        		</div>
					        		<div className={ compromisso3ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 3) }>
					        			<span className="btn__text">Educar</span>
					        			<div className="btn__loader"></div>
					        		</div>
				        		</div>
			        		</Swipeable>
			        		<Swipeable
			        			className={ slideClassItem.join(' ') }
			        			onSwipedLeft={ this.changeCompromissosMobileNext }
			        			onSwipedRight={ this.changeCompromissosMobilePrev }>

			        			<Compromisso
			        				icon={ this.images.quem_somos_perfil_icon_rep }
			        				title="Representar"
			        				text="Um mercado forte se constrói com instituições fortes e bem representadas. Isso é feito de duas formas: promovendo o diálogo com o governo, apresentando e discutindo propostas de melhorias do mercado e propondo boas práticas de negócios, que são seguidas voluntariamente pelos associados."
			        				slug="representar"
			        				/>

			        			<Compromisso
			        				icon={ this.images.quem_somos_perfil_icon_aut }
			        				title="Autorregular"
			        				text="Criamos regras de adesão voluntária feitas pelo próprio mercado, para o mercado e em prol do mercado. Do outro lado, nossa equipe técnica acompanha, supervisiona e orienta as instituições em relação ao cumprimento dessas exigências, que são consolidadas em códigos de autorregulação."
			        				slug="autorregular"
			        				/>

			        			<Compromisso
			        				icon={ this.images.quem_somos_perfil_icon_inf }
			        				title="Informar"
			        				text="Principal provedora de informações dos segmentos de mercado que representamos, nossa base de dados tem consistência e transparência. Entre as informações divulgadas, há referências de preços e índices que revelam o desempenho de carteiras de ativos e estudos específicos de interesse dos associados."
			        				slug="informar"
			        				/>

			        			<Compromisso
			        				icon={ this.images.quem_somos_perfil_icon_edu }
			        				title="Educar"
			        				text="A educação de investidores e profissionais ajuda a elevar os padrões de qualidade dos mercados. As ações de capacitação têm efeito multiplicador e incluem certificações, educação continuada (cursos) e divulgação de conteúdos sobre educação financeira."
			        				slug="educar"
			        				/>
			        		</Swipeable>
		        		</div>

		        		<div className="views__content views__content--section views__content--empresas row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
					        			<h2 className="section_title">Empresas que participamos</h2>
					        			<p className="section_subtitle">
					        				Nosso desempenho é fortalecido por meio da participação em duas empresas com objetivos relacionados aos da Associação:
					        				<span className="gri_label"><text>GRI 102-2, 102-13</text></span>
					        			</p>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section brands__section row">

			        		<div className="container">
				        		<div className="column column--half column--padding-right column--border-right">
				        			<Fade bottom>
					        			<img src={ this.images.quem_somos_perfil_rtm } alt="RTM" />
					        			<p>
					        				Criada em 1997, a empresa é a maior provedora de serviços para integração do mercado financeiro brasileiro. Está presente em 19 estados, conectando cerca de 500 instituições de todos os portes e 24 provedores de informações e serviços. Oferece infraestrutura de telecomunicações e soluções de tecnologia em ambiente de nuvem privada. Detemos 80% da RTM e a B3 é dona dos outros 20%.
										</p>
				        			</Fade>
				        		</div>

				        		<div className="column column--half column--padding-left">
				        			<Fade bottom>
					        			<img src={ this.images.quem_somos_perfil_galgo } alt="Galgo" />
					        			<p>
					        				Estamos entre as 13 instituições acionistas da Galgo S/A, empresa criada em 2016 para administrar o Sistema Galgo, que padroniza as transferências de informações entre instituições que atuam na indústria de fundos.
										</p>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>
		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { QuemSomosPerfil };
